import { useState } from 'react'
import isEmpty from 'lodash-es/isEmpty'

import { EMPTY_LIST } from '../../../constants/common'
import { useInlineNotifications } from '../../../hooks'
import { FormikForm } from '../../Formik'

import { FLAT_FORM_INITIAL_VALUES } from './FlatForm.constants'
import {
  getFlatFormPayload,
  getFlatFormServerErrors,
  getFlatFormSuccessData,
  getFlatFormValidationSchema,
} from './FlatForm.utils'
import { FlatFormFormFields } from './FlatFormFormFields'

function FlatForm({
  FormContainer,
  containerProps,
  initialValues = FLAT_FORM_INITIAL_VALUES,
  onCancel,
  onError,
  onSubmit,
  onSuccess,
  ...restProps
}) {
  const [files, setFiles] = useState(EMPTY_LIST)

  const { handleAddNotification, handleRemoveNotification, notifications } =
    useInlineNotifications()

  const validationSchema = getFlatFormValidationSchema()

  function handleSubmit(values, { setErrors, setSubmitting }) {
    const payload = getFlatFormPayload(values, files)

    onSubmit(payload)
      .then(({ data }) => {
        onSuccess?.(getFlatFormSuccessData(data, values))
      })
      .catch(({ response }) => {
        setSubmitting(false)

        if (isEmpty(response?.data)) {
          onError?.()
        } else {
          setErrors(getFlatFormServerErrors(response.data))
        }
      })
  }

  return (
    <FormikForm
      Container={FormContainer}
      containerProps={containerProps}
      initialValues={initialValues}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      <FlatFormFormFields
        {...restProps}
        files={files}
        notifications={notifications}
        setFiles={setFiles}
        onCancel={onCancel}
        onRemoveNotification={handleRemoveNotification}
        onSetNotification={handleAddNotification}
      />
    </FormikForm>
  )
}

export default FlatForm
